
type Props = {
    width?: number | string;
    height?: number | string;
    className?: string;
    style?: React.CSSProperties;
    id?: string | number;
};

export function ClockIcon({ width = 7, height = 7, className, style }: Props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 7 7"
            fill="none"
            className={className}
            style={style}
        >
            <path fillRule="evenodd" clipRule="evenodd" d="M6.66667 3.33333C6.66667 5.17427 5.17427 6.66667 3.33333 6.66667C1.49238 6.66667 0 5.17427 0 3.33333C0 1.49238 1.49238 0 3.33333 0C5.17427 0 6.66667 1.49238 6.66667 3.33333ZM3.125 3.69417C2.99607 3.61973 2.91667 3.4822 2.91667 3.33333V2.25C2.91667 2.01988 3.1032 1.83333 3.33333 1.83333C3.56347 1.83333 3.75 2.01988 3.75 2.25V3.09277L4.6242 3.5975C4.8235 3.71253 4.89177 3.96737 4.7767 4.16667C4.66167 4.36597 4.40683 4.43423 4.20753 4.31917L3.125 3.69417Z" fill="white"/>
        </svg>
    );
}

export default ClockIcon;